export default __webpack_public_path__ + "static/media/forward-arrow-ami.9758f2e6.svg";